<div class="app-login-container">
	<main class="main d-flex align-items-center">
		<div class="container">
			<div class="row">
				<div class="mx-auto">
					<div class="card-group">
						<div class="card p-4 app-login-container__form">
							<div class="card-header bg-transparent app-login-container__form-header" *ngIf="!isInsideIframe">
								<img src="assets/img/brand/ClassValuation-logo-XS-SM.png" />
							</div>
							<div class="card-body">
								<div class="mb-3 app-login-container__card-content">
									<div [innerHTML]="authFailMsg" class="app-login-container__info-text"></div>
									<button
										(click)="onSubmit()"
										*ngIf="showButton"
										class="btn cv-btn-secondary px-7  app-login-container__button"
									>
										<span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
										<span *ngIf="!isLoading">Sign In</span>
									</button>
								</div>
							</div>
						</div>
					</div>

					<br />
					<div class="text-muted app-login-container__footer" *ngIf="!isInsideIframe">
						&copy; {{ today | date: 'yyyy' }} Class Valuation LLC
					</div>
				</div>
			</div>
		</div>
	</main>
</div>
